import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 13, height: 10, viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M1 3.625L5.23077 8L12 1", strokeWidth: 2 }) });
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
